(function() {
    'use strict';

    angular
        .module('quilinkApp')
        .controller('InboxController', InboxController);

    InboxController.$inject = ['$stateParams', '$state', '$sce', 'Message', 'Principal', 'Discussion', 'User', 'Picture'];

    function InboxController($stateParams, $state, $sce, Message, Principal, Discussion, User, Picture) {
        var vm = this;
        vm.trustAsHtml = $sce.trustAsHtml
        vm.discussionId = $stateParams.discussionId ? parseInt($stateParams.discussionId) : null;
        vm.currentDiscussion = {
            id: vm.discussionId
        };
        vm.me = {};
        vm.newMessage = {
            content: ''
        };
        vm.discussions = [];
        vm.closed = false;

        Principal.identity().then(function (me) {
            vm.me = me;
        });
        Discussion.query(onFetchCompleted);
        if (vm.discussionId) {
            Discussion.get({id: vm.discussionId}, onGetDiscussionCompleted);
        }

        vm.sendNewMessage = sendNewMessage;
        vm.scrollToBottom = scrollToBottom;

        function onFetchCompleted(discussions) {
            var conversations = [];

            // Replace discussion.members by discussion.contact
            // Add a discussion.contact.picture field
            discussions.forEach(function (discussion) {
                var d = discussion;
                if (d.admin) {
                    if (vm.me.authorities.indexOf("ROLE_ADMIN") > -1) {
                        d.contact = d.members[0];
                        Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                            d.contact.picture = picSrc;
                        });
                    } else {
                        d.contact = {
                            id: 0,
                            firstName: "Axenteev",
                            lastName: "",
                            picture: "../content/images/axenteev-icon.svg"
                        };
                    }
                } else {
                    if (d.members[0].id !== vm.me.id) {
                        d.contact = d.members[0];
                    } else {
                        d.contact = d.members[1];
                    }
                    Picture.getProfilePictureByEmail(d.contact.email).then(function (picSrc) {
                        d.contact.picture = picSrc;
                    });
                }
                conversations.push(d);
            });

            vm.discussions = conversations;
        }

        function onGetDiscussionCompleted(discussion) {
            vm.currentDiscussion = discussion;
            Message.query({ discussionId: vm.currentDiscussion.id }, onGetMessagesCompleted);
        }

        function onGetMessagesCompleted(messages) {
            vm.currentDiscussion.messages = messages;
            vm.currentDiscussion.messages.forEach(function (message) {
                Picture.getProfilePictureByEmail(message.sentBy.email).then(function (picSrc) {
                    message.sentBy.picture = picSrc;
                });
            })
        }

        function sendNewMessage() {
            if (vm.currentDiscussion.id && vm.newMessage.content.length > 0) {
                vm.newMessage.discussion = vm.currentDiscussion;
                vm.newMessage.sentBy = vm.me;
                Message.create(vm.newMessage, onCreateMessageCompleted);
            }
        }

        function onCreateMessageCompleted() {
            $state.reload();
        }

        function scrollToBottom() {
            var wrapper = angular.element(document.querySelector('#message-wrapper'));
            var container = angular.element(document.querySelector('#message-container'));
            container[0].scrollTop = wrapper[0].offsetHeight;
            return true;
        }
    }
})();
